import formsReducer, {
  disableForm,
  enableForm,
  clearForm,
  setFormErrors
} from "../lib/formsReducer";
import entitiesReducer from "../lib/entitiesReducer";
import * as actions from "./actions";
import * as fieldCategoriesTranslationActions from "../fieldCategoriesTranslations/actions";
import { Record, Map, fromJS } from "immutable";
import { isApiCall } from "../app/schema";

import Forms from "./forms";
import Sections from "./sections";

const feature = "sections";

const START = "_START";
const SUCCESS = "_SUCCESS";
const ERROR = "_ERROR";

const InitialState = Record({
  forms: new Forms(),
  sections: new Sections()
});

const initialState = new InitialState();

function revive() {
  return initialState.merge({});
}

export default function SectionsReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return revive(state);

  if (isApiCall(action.type)) {
    if (
      action.payload &&
      action.payload.entities &&
      action.payload.entities.sections
    ) {
      state = state.updateIn(["sections", "entities"], map =>
        map.mergeDeep(action.payload.entities.sections)
      );
    }
  }

  switch (action.type) {
    case actions.GET_SECTION + START: {
      return state.setIn(["sections", "loading"], true);
    }
    case actions.GET_SECTION + SUCCESS: {
      return state.setIn(["sections", "loading"], false);
    }
    case actions.GET_SECTION + ERROR: {
      return state.setIn(["sections", "loading"], false);
    }

    case actions.PATCH_SECTION + START: {
      return state.setIn(["sections", "loading"], true);
    }
    case actions.PATCH_SECTION + SUCCESS: {
      return state.setIn(["sections", "loading"], false);
    }
    case actions.PATCH_SECTION + ERROR: {
      return state.setIn(["sections", "loading"], false);
    }

    case actions.DELETE_SECTION + START: {
      return state.deleteIn(["sections", "entities", action.payload.uid]);
    }

    case actions.GET_SECTION_FIELDS + START: {
      return state.setIn(["sections", "loading"], true);
    }
    case actions.GET_SECTION_FIELDS + SUCCESS: {
      state = state.setIn(
        ["sections", "entities", action.meta.uid, "fields"],
        action.payload.result
      );
      return state.setIn(["sections", "loading"], false);
    }
    case actions.GET_SECTION_FIELDS + ERROR: {
      return state.setIn(["sections", "loading"], false);
    }

    case actions.POST_SECTION_FIELDS + START: {
      return disableForm(state, "createSectionField");
    }
    case actions.POST_SECTION_FIELDS + SUCCESS: {
      state = clearForm(state, "createSectionField", Forms);
      return enableForm(state, "createSectionField");
    }
    case actions.POST_SECTION_FIELDS + ERROR: {
      state = enableForm(state, "createSectionField");
      return setFormErrors(state, "createSectionField", action.payload.errors);
    }

    case actions.GET_SECTION_GALLERIES + START: {
      return state.setIn(["sections", "loading"], true);
    }
    case actions.GET_SECTION_GALLERIES + SUCCESS: {
      state = state.setIn(
        ["sections", "entities", action.meta.uid, "galleries"],
        action.payload.result
      );
      return state.setIn(["sections", "loading"], false);
    }
    case actions.GET_SECTION_GALLERIES + ERROR: {
      return state.setIn(["sections", "loading"], false);
    }

    case actions.POST_SECTION_GALLERIES + START: {
      return disableForm(state, "createSectionGallery");
    }
    case actions.POST_SECTION_GALLERIES + SUCCESS: {
      state = clearForm(state, "createSectionGallery", Forms);
      return enableForm(state, "createSectionGallery");
    }
    case actions.POST_SECTION_GALLERIES + ERROR: {
      state = enableForm(state, "createSectionGallery");
      return setFormErrors(
        state,
        "createSectionGallery",
        action.payload.errors
      );
    }

    case actions.SET_IS_EDIT_SECTION_MODAL_VISIBLE: {
      return state.setIn(
        ["sections", "isEditModalVisible"],
        action.payload.isVisible
      );
    }
    case actions.SET_IS_REMOVE_SECTION_MODAL_VISIBLE: {
      return state.setIn(
        ["sections", "isRemoveModalVisible"],
        action.payload.isVisible
      );
    }

    case actions.SET_IS_ADD_GALLERY_MODAL_VISIBLE: {
      return state.setIn(
        ["forms", "createSectionGallery", "isAddModalVisible"],
        action.payload.isVisible
      );
    }

    case actions.MOVE_SECTION: {
      const { dragIndex, hoverIndex } = action.payload;
      if (hoverIndex === "1") {
        return state.setIn(
          ["sections", "entities", dragIndex, "columnNumber"],
          1
        );
      } else if (hoverIndex === "2") {
        return state.setIn(
          ["sections", "entities", dragIndex, "columnNumber"],
          2
        );
      } else {
        const dragIndexSort = state.getIn([
          "sections",
          "entities",
          dragIndex,
          "sort"
        ]);
        const hoverIndexSort = state.getIn([
          "sections",
          "entities",
          hoverIndex,
          "sort"
        ]);
        const hoverIndexColumnNumber = state.getIn([
          "sections",
          "entities",
          hoverIndex,
          "columnNumber"
        ]);
        if (hoverIndexSort > dragIndexSort) {
          state = state.setIn(
            ["sections", "entities", dragIndex, "sort"],
            hoverIndexSort + 5
          );
        } else if (hoverIndexSort < dragIndexSort) {
          state = state.setIn(
            ["sections", "entities", dragIndex, "sort"],
            hoverIndexSort - 5
          );
        } else {
          state = state.setIn(
            ["sections", "entities", dragIndex, "sort"],
            hoverIndexSort
          );
          state = state.setIn(
            ["sections", "entities", hoverIndex, "sort"],
            hoverIndexSort + 5
          );
        }
        return state.setIn(
          ["sections", "entities", dragIndex, "columnNumber"],
          hoverIndexColumnNumber
        );
      }
    }

    case fieldCategoriesTranslationActions.GET_FIELD_CATEGORIES_TRANSLATION_SECTIONS: {
      return state.setIn(["sections", "loading"], true);
    }
    case fieldCategoriesTranslationActions.GET_FIELD_CATEGORIES_TRANSLATION_SECTIONS_SUCCESS: {
      state = state.setIn(
        ["sections", "entities"],
        fromJS(action.payload.entities.sections)
      );
      return state.setIn(["sections", "loading"], false);
    }
    case fieldCategoriesTranslationActions.GET_FIELD_CATEGORIES_TRANSLATION_SECTIONS_ERROR: {
      return state.setIn(["sections", "loading"], false);
    }
  }

  return entitiesReducer(
    formsReducer(state, feature, action, Forms),
    feature,
    action
  );
}



// WEBPACK FOOTER //
// ./src/common/sections/reducer.js